import * as React from 'react';
import { Button, ButtonType } from 'components/button/index';
import { ToggleArrow } from 'components/toggle-arrow';
import {IFilterFooter} from '../filter.interface';

export const FilterFooter = (props: IFilterFooter) => {
    const onToggle = props.onToggleClick as () => void;
    const btnSettings = (
        <Button
            buttonType={ButtonType.Transparent}
            onClick={props.onSettingsClick}
            id="settings-filters-button"
            style={{ marginLeft: '0.5rem' }}
        >
            <i className="fa fa-cog" />
        </Button>
    );
    const btnSave = (
        <Button
            buttonType={ButtonType.Transparent}
            onClick={props.onSaveClick}
            style={{ marginLeft: '0.5rem' }}
            id="save-filters-button"
        >
            <i className="fa fa-save" />
        </Button>
    );
    const btnSavedFilters = (
        <Button
            buttonType={ButtonType.Transparent}
            onClick={props.onSavedFiltersClick}
            id="saved-filters-button"
        >
            Saved filters
        </Button>
    );
    return (
        <fieldset>
            <div className="filter-button-area">
                <Button
                    isDisabled={props.disableSubmit}
                    buttonType={ButtonType.Blue}
                    onClick={props.onApplyClick}
                    id="apply-filters-button"
                >
                    Apply
                </Button>
                <Button
                    buttonType={ButtonType.Transparent}
                    onClick={props.onClearClick}
                    id="clear-filters"
                    type="reset"
                >
                    Clear
                </Button>

                {props.onSaveClick && btnSave}
                {props.onSettingsClick && btnSettings}

                {props.disableExpand && <div style={{ float: 'right' }}>
                    {props.onSavedFiltersClick && btnSavedFilters}
                    <Button
                        buttonType={ButtonType.Transparent}
                        onClick={onToggle}
                    >
                        <ToggleArrow
                            isExpanded={props.isExpanded}
                        />
                    </Button>
                </div>}
            </div>
        </fieldset>
    )
}